import React from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';

import { ChatbotModal } from '../components/chatbot/ChatbotModal';
import ChatbotPage from '../pages/ChatbotPage';
import CreateSessionPage from '../pages/CreateSessionPage';
import InstallationGuidePage from '../pages/InstallationGuidePage';
import LookupPage from '../pages/LookupPage';
import NotFoundPage from '../pages/NotFoundPage';
import QRRedirectPage from '../pages/QRRedirectPage';
import V2QRRedirectPage from '../pages/V2QRRedirectPage';
import type { StorylineContext } from '../services/storylineContext';

interface LocationState {
  background?: ReturnType<typeof useLocation>;
  flowId?: string;
  guideContext?: StorylineContext;
}

export const AppRoutes: React.FC = () => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const background = location.state?.background;

  return (
    <>
      <Switch location={background || location}>
        {/* V2 routes */}
        <Route exact path="/v2" component={LookupPage} />
        <Route exact path="/v2/start" component={LookupPage} />
        <Route exact path="/v2/qr/:sku/:serial" component={V2QRRedirectPage} />
        <Route exact path="/v2/guide" component={InstallationGuidePage} />
        <Route exact path="/v2/chatbot" component={ChatbotPage} />

        {/* V1 routes at root level */}
        <Route exact path="/" component={LookupPage} />
        <Route exact path="/start" component={LookupPage} />
        <Route exact path="/qr/:sku/:serial" component={QRRedirectPage} />
        <Route exact path="/session" component={CreateSessionPage} />
        <Route exact path="/guide" component={InstallationGuidePage} />
        <Route exact path="/chatbot" component={ChatbotPage} />

        {/* 404 */}
        <Route component={NotFoundPage} />
      </Switch>

      {/* Chatbot modal for both V1 and V2 */}
      {background && (location.pathname === '/chatbot' || location.pathname === '/v2/chatbot') && (
        <ChatbotModal
          flowId={location.state?.flowId}
          guideContext={location.state?.guideContext}
          onClose={() => history.goBack()}
        />
      )}
    </>
  );
};
